import { Query } from 'upstream-shared/models';
import { upstreamApi } from '../upstreamApi';
import { asyncAction } from './asyncAction';
import { READ_SERVER } from './actionTypes';

export function readSources(storeIdentifier: string, query: Query) {
  query.q = query.q || '*';
  query.skip = query.skip || 0;
  query.limit = query.limit || 25;
  query.filters = query.filters || {};

  return asyncAction({
    actionType: READ_SERVER,
    func: async () => (await upstreamApi.sources.search(query)).data,
    storeIdentifier,
    requestPayload: { query },
  });
}
